interface AuthType {
  Authorization: string;
}

export const authHeader = (): AuthType => {
  const token = "";

  return {
    Authorization: token,
  };
};
export function checkToken() {
  const token = false;

  if (!token) {
    return false;
  }
}
